export const requiredFields = {
  basic: ["first_name", "last_name", "country", "city", "address", "relation", "phone"],
  bank: [
    "bank_name",
    "branch_name",
    "bank_account_number",
    "bank_postal_code",
    "bank_branch_street",
    "bank_city",
    "bank_province",
  ],
  mobile: ["mobile_wallet_provider", "mobile_wallet_name", "mobile_wallet_account_number"],
  card: ["card_holder_one", "card_number_one", "card_expiry_one"],
  crypto: ["crypto_currency", "crypto_wallet_address"],
  cash: ["document_type", "document_number"],
};
